export default {
  tokenName: 'Nom du jeton',
  tokenExpirationTime: 'Temps d\'expiration du jeton',
  lastUsedDate: 'Date de dernière utilisation',
  lastUpdateDate: 'Date de dernière mise à jour',
  allowVariables: 'Autoriser les variables dans le jeton',
  tokenExpirationHelpText: 'Champ de réponse API au format JSON d\'où le "jeton" est extrait',
  tokenCanNotBeDeleted: 'Le jeton ne peut pas être supprimé, il est utilisé dans :\n{rules}',
  urlHelp: '<p>Les variables accessibles sont : <strong>.Env</strong></p>'
    + '<i>Par exemple :</i>'
    + '<pre>"https://exampleurl.com?env={{ .Env.System.ENV_var }}"</pre>',
};
